import AxiosAPI from "./AxiosAPI";


export const handleAddAttendance= async (data) => {  
  try {
    const response = await AxiosAPI.post(
      `/staff/addattendance`,
      data,{
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};



export const fetchAttendance = async (
  StoreID, // Made compulsory by removing default null value
  from = 0,
  size = 25,
  fromDate = null,
  toDate = null,
  searchParam = null,
  status
) => {
  try {
    let apiUrl = `staff/attendance`;
    let queryParams = [];

    // Check if any filter is active
    // const hasActiveFilters = [fromDate, toDate, searchParam].some(
    //   param => param !== null && param !== undefined && param !== ''
    // );

    // Only include from/size if NO filters are active
      if(from){
      queryParams.push(`from=${from}`);
      }
      if(size){
      queryParams.push(`size=${size}`);
      }

    // Always include StoreID
    queryParams.push(`StoreID=${StoreID}`);

    // Add other parameters if they exist
    if (fromDate) {
      queryParams.push(`fromDate=${fromDate}`);
    }
    if (toDate) {
      queryParams.push(`toDate=${toDate}`);
    }
    if (searchParam) {
      queryParams.push(`searchParam=${searchParam}`);
    }
       if (status) {
      queryParams.push(`status=${status}`);
    }

    apiUrl += queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

    const response = await AxiosAPI.get(apiUrl);
    return response.data;
  } catch (err) {
    console.error('Error fetching attendance:', err);
    throw err;
  }
};





export const handleEditAttendance= async (data) => {  
  try {
    const response = await AxiosAPI.put(
      `/staff/attendance/${data.key}`,
      data,{
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};